import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { STATS } from "../data/content";

const Counter = ({ value, prefix, suffix, decimals }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState("0");

  useEffect(() => {
    if (!inView) return;
    const duration = 1600;
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 4);
      setDisplay((value * eased).toFixed(decimals));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value, decimals]);

  return (
    <span ref={ref} className="font-heading text-[1.25rem] sm:text-5xl lg:text-6xl font-extrabold text-[#A3E635] text-glow-lime whitespace-nowrap">
      {prefix}{display}{suffix}
    </span>
  );
};

export const Stats = () => (
  <section data-testid="stats-section" className="relative max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28">
    <p className="font-mono2 text-xs sm:text-sm tracking-[0.25em] text-[#A3E635] uppercase mb-4">
      // Results that move the needle
    </p>
    <h2 className="font-heading text-3xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight leading-[1.0] max-w-3xl mb-14">
      Numbers don't whisper. <span className="text-[#A3E635]">They roar.</span>
    </h2>
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-2xl overflow-hidden border border-white/10">
      {STATS.map((s, i) => (
        <div
          key={i}
          data-testid={`stat-card-${i}`}
          className="bg-[#0A0C0E] p-6 sm:p-10 flex flex-col gap-4 hover:bg-[#121519] transition-colors duration-500"
        >
          <Counter {...s} />
          <span className="text-sm text-slate-400 leading-relaxed">{s.label}</span>
        </div>
      ))}
    </div>
  </section>
);
